import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    awsCertificatesList: selectors.awsCertificatesListSelector(state),
    error: selectors.errorSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isListLoading'),
    currentPage: selectors.currentPageSelector(state),
    total: selectors.totalSelector(state),
    isNeedToFetchList: selectors.isNeedToFetchListSelector(state)
  }
}

const mapDispatchToProps = {
  changeCurrentPage: actions.changeCurrentPage,
  changePageSize: actions.changePageSize,
  fetchAwsCertificatesList: actions.fetchAwsCertificatesList,
  removeAwsCertificate: actions.removeAwsCertificate
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
